import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=5522dca4&"
import script from "./ComponentList.vue?vue&type=script&lang=ts&"
export * from "./ComponentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports